import React, { useState, useEffect } from 'react'
import { Box, TextInput, Flex, Group, Button, Select } from '@mantine/core'
import { validation } from '../../../plugins/validation'
import { updateSourcingRequest } from '../../../services/sourcing-request'
import { notificationSuccess, notificationError } from '../../ui/Notifications'

const defaultVal = {
  request_number: '',
  status: ''
}

const formValidation = {
  request_number: {
    isError: false,
    message: ''
  }
}

const defaultStatus = [
  {
    value: '82',
    label: 'In Review'
  },
  {
    value: '83',
    label: 'In Progress'
  },
  {
    value: '84',
    label: 'Finished'
  },
  {
    value: '85',
    label: 'Canceled'
  },
]

const FormChangeStatus = ({ dataSourcingRequest, onCloseModal, reloadList }) => {
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [loadingForm, setLoadingForm] = useState(false)

  const submitChangeStatus = async (form) => {
    setLoadingForm(true)
    const validateForm = {
      request_number: form.request_number,
    }
    const isError = validation(validateForm, setValidationForm)
    if (isError) {
      setLoadingForm(false)
      return
    }
    const mappingIdProduct = dataSourcingRequest.products.map((val) =>{
      return val.id
    })
    const payload = {
      request_number: form.request_number,
      title: dataSourcingRequest.title,
      brand: dataSourcingRequest.brand,
      quantity: dataSourcingRequest.quantity,
      quantity_unit: dataSourcingRequest.quantity_unit,
      currency: dataSourcingRequest.currency,
      price: dataSourcingRequest.price,
      user_id: dataSourcingRequest.user.id,
      agent_id: dataSourcingRequest.agent.id,
      description: dataSourcingRequest.description,
      status: defaultStatus.find(val => val.value === form.status).label.toLowerCase(),
      products: dataSourcingRequest.products.length > 0 ? mappingIdProduct : []
    }
    try {
      const response = await updateSourcingRequest(dataSourcingRequest.id, payload)
      if (response.success) {
        onCloseModal()
        reloadList()
        notificationSuccess('Update Sourcing Request Successfully', 'You have been updated data sourcing request')
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      const captionMessageError = Object.keys(errorMessage) ? errorMessage : 'Please recheck your form'
      notificationError('Update Sourcing Request Error', captionMessageError)
    } finally {
      setLoadingForm(false)
    }
  }

  useEffect(() => {
    if (dataSourcingRequest) {
      handleSetForm(dataSourcingRequest)
    }
    // eslint-disable-next-line
  }, [dataSourcingRequest])

  const handleSetForm = (val) => {
    const detail = {
      request_number: val.request_number,
      status: val.status.length > 0 ? `${val.status[0].id}` : null
    }
    setFormData(detail)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  return (
    <Box>
      <Box mb='md'>
        <TextInput
          name='request_number'
          value={formData.request_number}
          label='RFQ Number'
          placeholder='Input RFQ Number'
          error={validationForm.request_number.isError ? `${validationForm.request_number.message}` : ''}
          onChange={(val) => handleChangeForm('request_number', val.target.value)}
          withAsterisk
          size='xs'
        />
      </Box>
      <Box mb='md'>
        <Select
          name='status'
          value={formData.status}
          label='Select Status'
          data={defaultStatus}
          onChange={(val) => handleChangeForm('status', val)}
          size='xs'
          allowDeselect={false}
          withAsterisk
        />
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseModal}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitChangeStatus(formData)}>Submit</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormChangeStatus